import React, { FC } from 'react';
import { MESSAGE_TYPES } from '@sv-support-sdk/utils/src/constants/chatMessages';
import { IMessage } from '@sv-support-sdk/chat-shared-types/src/common/messages';

import { addMessage } from '../../../store/slices/messages';
import MessagePlaceholder from '../../ui/Content/Message/MessagePlaceholder';
import Headline from '../../ui/Typography/Headline';
import Rating from '../../Feedback/Rating';
import { useAppDispatch } from '../../../store/hooks';
import { sendFeedback } from '../../../store/actions/chat';
import { $l } from '../../../locales';

interface IMessageFeedback {
  message: IMessage;
}

const Feedback: FC<IMessageFeedback> = ({ message }) => {
  const dispatch = useAppDispatch();
  const onRateSelect = async (score: number) => {
    await dispatch(sendFeedback(message.chatId, { score, hash: message.hash || '' }, true));

    dispatch(
      addMessage({
        type: MESSAGE_TYPES.NOTIFICATION,
        title: $l('THANK_YOU'),
        message: $l('WE_APPRECIATE'),
        uuid: message.uuid,
      }),
    );
  };

  return (
    <MessagePlaceholder minHeight="none">
      <Headline fontSize="14" lineHeight="20" fontWeight="700">
        {$l('PLEASE_RATE')}
      </Headline>
      <Rating rateSelect={onRateSelect} />
    </MessagePlaceholder>
  );
};

export default Feedback;
